<template>
    <v-container>
        <v-row no-gutters>
            <v-col cols="12" align="right" class="mt-6">
                <v-btn-toggle v-model="filtroAgenda" @change="cambioAgenda">
                    <v-btn value="AUE" :disabled="disabled">
                        {{ $t("componentes.selector-agenda.AUE") }}
                    </v-btn>
                    <v-btn value="AUV" :disabled="disabled">
                        {{ $t("componentes.selector-agenda.AUV") }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "SelectorAgenda",
    props: ["disabled"],
    data: () => ({
        filtroAgenda: null,
    }),
    methods: {
        cambioAgenda(filtroAgenda) {
            this.$router.push({
                path: this.$route.fullPath,
                query: { filtroAgenda: filtroAgenda },
            });
        },
    },
    mounted() {
        this.filtroAgenda = this.$route.query.filtroAgenda;
    },
};
</script>
